import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { Button } from '../../shared/ui/Button';
import { PasswordField } from '../../shared/ui/PasswordField';
import { TextField } from '../../shared/ui/TextField';
import type { Credentials } from './api';

const schema = z.object({
  // Обычно e-mail; служебный администратор может входить по логину (admin).
  email: z.string().trim().min(1, 'Введите e-mail или логин'),
  password: z.string().min(8, 'Минимум 8 символов'),
});

interface Props {
  submitLabel: string;
  pending: boolean;
  errorMessage?: string;
  onSubmit: (values: Credentials) => void;
}

export function CredentialsForm({ submitLabel, pending, errorMessage, onSubmit }: Props) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Credentials>();

  const submit = handleSubmit((values) => {
    const parsed = schema.safeParse(values);
    if (!parsed.success) return;
    onSubmit(parsed.data);
  });

  return (
    <form onSubmit={submit} className="space-y-4">
      <TextField
        label="E-mail или логин"
        type="text"
        autoComplete="username"
        autoCapitalize="none"
        spellCheck={false}
        error={errors.email?.message}
        {...register('email')}
      />
      <PasswordField
        label="Пароль"
        autoComplete="current-password"
        error={errors.password?.message}
        {...register('password')}
      />

      {errorMessage && <p className="text-sm text-danger">{errorMessage}</p>}

      <Button type="submit" disabled={pending} className="w-full">
        {submitLabel}
      </Button>
    </form>
  );
}
